import {
  OrderManagementPermissions,
  SettingsPermissions,
} from "@redotech/account-common/permissions";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useContext } from "react";

interface DocumentsAccessInput {
  canManageDocumentSettings: boolean;
  canManageShipments: boolean;
  personalizedInsertsEnabled: boolean;
}

export function getDocumentsAccess({
  canManageDocumentSettings,
  canManageShipments,
  personalizedInsertsEnabled,
}: DocumentsAccessInput) {
  const canUsePersonalizedInserts =
    canManageShipments && personalizedInsertsEnabled;
  const landingDestination = canManageDocumentSettings
    ? "packing-slips"
    : canUsePersonalizedInserts
      ? "personalized-inserts"
      : undefined;
  return {
    canManageDocumentSettings,
    canUsePersonalizedInserts,
    landingDestination,
  };
}

export function useDocumentsAccess() {
  const canManageDocumentSettings = useHasPermission(
    SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
  );
  const canManageShipments = useHasPermission(
    OrderManagementPermissions.MANAGE_SHIPMENTS,
  );
  const team = useContext(TeamContext);
  return getDocumentsAccess({
    canManageDocumentSettings,
    canManageShipments,
    personalizedInsertsEnabled:
      !!team?.settings.outboundLabels?.personalizedSlipsMonetization?.enabled,
  });
}
